export default __webpack_public_path__ + "static/media/3-1820x480多多.79598a2f.jpg";